import React, { useRef } from 'react'
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import zoomIcon from '../../../assets/images/zoom-icon.png'
import flaggedIcon from '../../../assets/images/flag-orange.png'
import exclamationOrange from '../../../assets/images/exclamation-orange.png'
import sendButton from '../../../assets/images/send-button.png'
import Header from './Conversation/Header';
import { useOpenChatMutation, useSendMessageMutation } from '../../../services/chatApi';
import { useUpdateBookingStatusMutation } from '../../../services/coachApi';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useCallback } from 'react';
import moment from 'moment-timezone';
import { BASE_URL } from '../../../keys';
import ReportModal from '../Chat/Modals/ReportModal'
import loader from '../../../assets/images/loader.gif'
import Button from '../../../UI/Button';
import RestrictIcon from '../../../assets/images/restrict-icon.png'
import { ToastContainer, toast } from 'react-toastify';
import VideoJoinModal from './Modals/VideoJoinModal';
import api from '../../../services/api';
import { timeDifferenceCalculator } from 'time-difference-calculator';
import datetimeDifference from "datetime-difference";
import ReactTimeAgo from 'react-time-ago'
import FeedbackCoach from '../../Client/FindTherapist/Popups/FeedbackCoach';
import { inline, Tooltip as ReactTooltip } from 'react-tooltip'
import HTMLReactParser from 'html-react-parser'
import { IoDownload, IoDownloadOutline } from 'react-icons/io5';
import { MdFileDownload } from "react-icons/md";
function checkForLinkInText(text) {
    let urlRegex3 = /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;
    return text.replace(urlRegex3, function (url) {
        return '<a href="' + url + '" target="_blank" className="underline">' + url + '</a>';
    });
}

const Conversation = ({ socket }) => {

    const [modalDisplay, setModalDisplay] = useState(false);
    const [openChat, { isLoading: chatOpenLoading, isSuccess: chatOpenSuccess }] = useOpenChatMutation();
    const [sendMessage, { isLoading: sendMessageLoading, isError: sendMessageError }] = useSendMessageMutation();
    const [updateBookingStatus] = useUpdateBookingStatusMutation();
    const [pageNo, setPageNo] = useState(1);
    const currentChatUser = useSelector(state => state.chatUserReducer.user);
    const [messages, setMessages] = useState([]);
    const [currentMessage, setCurrentMessage] = useState("");
    const [fileURL, setFileURL] = useState(null);
    const [file, setFile] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const roomId = useSelector((state) => state.client.roomId);
    const [barStyle, setbarStyle] = useState("");
    const [videoModal, setvideoModal] = useState(false);
    const [videoLink, setvideoLink] = useState(null);
    const [feedback, setfeedback] = useState(false);
    const [flaggedStatus, setFlaggedStatus] = useState("");
    const [countDown, setcountDown] = useState(null);
    const isReported = localStorage.getItem('isReported');
    const [visible, setVisible] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [hideShowMoreBtn, setHideShowMoreBtn] = useState(false);
    const msgStartRef = useRef(null);
    const messagesEndRef = useRef(null);
    const sendFileRef = useRef(null);
    const shouldScrollRef = useRef(false);
    const lastSentMessageRef = useRef(null);
    console.log('currentChatUser', currentChatUser);
    // console.log('socket', socket);
    const userDetails = useSelector(state => state.userReducer)
    console.log('userDetails', userDetails?.user?.data);
    const deviceTimezone = localStorage.getItem('device_timezone')
    const userTimezone = userDetails?.user?.data?.timezone?.name || deviceTimezone;
    useEffect(() => {
        if (shouldScrollRef.current) {
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
            shouldScrollRef.current = false;
        }
    }, [messages]);
    const getUserTime = (date, time) => {
        if (!date || !time) return null;

        const utcDateTime = `${date}T${time}:00Z`; // e.g., '2025-08-06T10:20:00Z'
        return moment.utc(utcDateTime).tz(userTimezone);
    };
    useEffect(() => {
        setFlaggedStatus(isReported)
    }, [isReported])

    const fetchMessages = async (page, userChanged = false) => {
        const formData = new FormData();
        formData.append('person_id', currentChatUser?.user_id);
        formData.append('page_no', page);

        try {
            const response = await openChat(formData);
            // console.log('response?.data?.data', response?.data?.data);
            setFlaggedStatus(response.data.is_user_flagged);
            if (userChanged) {
                setHideShowMoreBtn(false)
                setMessages(response?.data?.data);
                const clientTimeduration = response?.data?.coch_details?.coach_time_slot;
                localStorage.setItem('client_time_slot', clientTimeduration);
                //.. scrollToBottom();
                shouldScrollRef.current = true
            } else {
                if (response?.data?.data.length == 0) {
                    setHideShowMoreBtn(true)
                }
                setMessages([...response?.data?.data, ...messages])
                scrollToTop();
            }
            localStorage.setItem('livBookingId', response?.data?.data.at(-1).booking_id)

        } catch (error) {


        }
        return messages;
    }

    const chatOpenHandler = useCallback(async (page, userChanged = true) => {
        fetchMessages(page, userChanged)
    }, [currentChatUser?.user_id]);
    // const chatOpenHandler = useCallback(
    //     (page, userChanged = true) => {
    //         fetchMessages(page, userChanged);
    //     },
    //     [currentChatUser, messages]
    // );
    const savedClientTimeSlot = localStorage.getItem('client_time_slot');
    // console.log(savedClientTimeSlot);
    let sessionDurationMinutes = 60; // default
    if (savedClientTimeSlot) {
        // Extract number from string like "60_min"
        const match = savedClientTimeSlot.match(/\d+/);
        if (match) {
            sessionDurationMinutes = parseInt(match[0], 10);
        }
    }
    // console.log(sessionDurationMinutes);

    useEffect(() => {
        setPageNo(1);
        chatOpenHandler(1, true);
        setErrorMessage("");
    }, [currentChatUser?.user_id, fileURL])
    useEffect(() => {
        if (!socket || !roomId) return;

        console.log("Emitting join_room:", roomId);
        socket.emit("join_room", roomId);  // ← ADD THIS

    }, [socket, roomId]);

    useEffect(() => {
        setIsOpen(false)
        setFileURL(null)
    }, [currentChatUser])

    const handlePageChange = () => {
        setPageNo(prev => prev + 1);
        fetchMessages(pageNo + 1);
    }

    const scrollToTop = () => {
        // console.log('scrollToTop triggered');
        msgStartRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" })
    }

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" })
    }
function inferMessageType(fileLink) {
    if (!fileLink || fileLink.length <= 2) return undefined;
    
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    const ext = fileLink.split('.').pop()?.split('?')[0]?.toLowerCase();
    
    if (fileLink.startsWith('data:image')) return 'i';
    if (imageExts.includes(ext)) return 'i';
    if (ext) return 'f';
    
    return undefined;
}
    // Socket useEffect — dedup only against lastSentMessageRef, not prev messages
    useEffect(() => {
        if (!socket) return;
        console.log("roomid", roomId);

        const handleReceiveMessage = (data) => {
            console.log("message received:", data);

            const sent = lastSentMessageRef.current;
            console.log("sent message:", sent);

            const isEcho =
                sent &&
                sent.message === data?.message &&
                sent.file_link === data?.file_link &&
                sent.booking_id === data?.booking_id &&
                sent.from_user_id === data?.from_user_id;

            if (isEcho) {
                // This is just the socket echo of our own send — skip it
                lastSentMessageRef.current = null; // consume it so next message isn't blocked
                return;
            }
 const normalizedData = {
        ...data,
         file_name: data.file_name || '',  // ✅ add this
        created_at: data.created_at || new Date().toISOString(),
         message_type: data.message_type || inferMessageType(data.file_link),
    };
            // All other messages (client replies, new messages) always get added
            setMessages((prev) => [...prev, normalizedData]);
            shouldScrollRef.current = true;
        };

        socket.on("receive_message", handleReceiveMessage);

        return () => {
            console.log("remove");

            socket.off("receive_message", handleReceiveMessage);
        };
    }, [socket, roomId]);

    
    const sendMessageHandler = async () => {
        // console.log('Coach Chat');
        if (currentMessage !== "" || file) {
            const messageData = {
                room: roomId,
                from_user_id: userDetails?.user?.data?.id,
                //from_user_id: user.user_id,
                message: currentMessage,
                booking_id: localStorage.getItem('livBookingId'),
                time: new Date(Date.now()).getHours() + ":" + new Date(Date.now()).getMinutes(),
                message_time: new Date(),
                 created_at: new Date().toISOString(),
                file_link: fileURL,
                file_name: file?.name || '',
                message_type: file
                    ? (['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(file.type) ? 'i' : 'f')
                    : undefined,
            }
            // Store what we just sent so socket echo can be identified
            lastSentMessageRef.current = {
                message: messageData.message,
                file_link: messageData.file_link,
                booking_id: messageData.booking_id,
                from_user_id: messageData.from_user_id,
                message_type: messageData.message_type,
            };
            // Add message to UI immediately (optimistic update)
            setMessages((prev) => [...prev, messageData]);
            shouldScrollRef.current = true
            await socket.emit("send_message", messageData);

            const formData = new FormData();
            formData.append('message_from', currentChatUser?.coach_id);
            formData.append('message_to', currentChatUser?.user_id);
            formData.append('booking_id', localStorage.getItem('livBookingId'));
            formData.append('message', currentMessage);
            formData.append('message_file', file);
            // rely on socket "receive_message" to append the sent message (prevents duplicate)
            const response = await sendMessage(formData);

            // chatOpenHandler(pageNo);
            shouldScrollRef.current = true
            //... scrollToBottom() //this happens when we add a chat and enter
            setCurrentMessage("")
            setFileURL(null);
            setFile(null);
            setIsOpen(false);
            // Clear after a short delay so only the immediate echo is blocked
            setTimeout(() => {
                lastSentMessageRef.current = null;
            }, 3000);
            if (response.error) {
                setErrorMessage(response.error.data.data.booking_id[0] || "Something went wrong! Please try again");
                // chatOpenHandler();
            }

        }
    }

    useEffect(() => {

        if (countDown?.days > 0) {
            return setbarStyle(`${100 / countDown.days}%`)
        } else if (countDown?.hour > 0) {
            return setbarStyle(`${100 / countDown.hour}%`)
        } else if (countDown?.days === 0) {
            return setbarStyle("100%")
        }

        // scrollToBottom()
    }, [currentChatUser, countDown])

    useEffect(() => {
        if (currentChatUser?.session_date && currentChatUser?.session_time) {
            const localDateTime = getUserTime(currentChatUser.session_date, currentChatUser.session_time);
            if (localDateTime) {
                DateTimeCal(localDateTime.format('YYYY-MM-DD HH:mm'));
            } else {
                // Handle or ignore if localDateTime is null
                // console.warn("Could not get user localDateTime");
            }
        }

    }, [messages, currentChatUser]);

    const handleVideoCall = () => {
        //   console.log(sessionDurationMinutes);

        const sessionStart = getUserTime(currentChatUser?.session_date, currentChatUser?.session_time);
        const now = moment().tz(userTimezone);
        // console.log(sessionStart);
        const diffMinutes = now.diff(sessionStart, 'minutes');
        //   console.log(diffMinutes);

        if (!sessionStart) {
            toast.warn("Could not determine session time.");
            return;
        }
        if (diffMinutes < 0) {
            toast.warn("Your session has not started yet!");
            return;
        }
        if (diffMinutes > sessionDurationMinutes) {
            toast.warn("Your session is already completed!");
            return;
        }

       

        // Allow join up to 60 minutes after start
        api.get(`common/get-booking-link/${currentChatUser?.last_message.booking_id}`, {
            headers: { authorization: `Bearer ${localStorage.getItem("livtoken")}` }
        })
            .then((res) => {
                setvideoLink(res.data.data.zoom_link);
                setvideoModal(true);
                localStorage.setItem('client_name', currentChatUser?.user_name)
                const formData = new FormData()
                formData.append('person_id', currentChatUser.user_id)
                formData.append('booking_id', currentChatUser?.last_message.booking_id)
                // console.log(currentChatUser.user_id ,currentChatUser?.last_message.booking_id);

                updateBookingStatus(formData)
                    .then((data) => {
                        // console.log(data);
                        // setHasUpdatedBooking(true);
                        //  setfeedback(true);
                    });
            })
            .catch((err) => {

                const apiError = err?.response?.data;
                //    console.log(apiError);
                if (apiError?.data?.error?.[0] === "Please give previous session a rating.") {

                    // extract booking_id from data_key
                    const prevBookingId = apiError?.data_key?.[0]?.[0];
                    const prevUserId = apiError?.data_key?.[0]?.[1];

                    // console.log("Feedback needed for booking:", prevBookingId);


                    setfeedback({

                        booking_id: prevBookingId,
                        user_id: prevUserId
                    });

                    return;
                }
                // setfeedback(true);
            });
        // }
        // else {
        //     toast.warn("Your session has ended or the join window has expired!");
        // }
    };



    const feedbackModal = () => {
        // setTimeout(() => {
        setfeedback(true)
        // }, 5000);
    }

    const feedbackClose = () => {
        setfeedback(false);
    }

    const DateTimeCal = (dateTime) => {

        const eventDate = Date.parse(dateTime);
        const eventCountdown = setInterval(() => {

            const now = new Date().getTime()
            const daysDivider = 1000 * 60 * 60 * 24
            const hourDivider = 1000 * 60 * 60
            const minutesDivider = 1000 * 60
            const secondsDivider = 1000


            const d = Math.floor(eventDate / daysDivider - now / daysDivider)
            const h = Math.floor((eventDate / hourDivider - now / hourDivider) % 24)
            const m = Math.floor((eventDate / minutesDivider - now / minutesDivider) % 60)
            const s = Math.floor((eventDate / secondsDivider - now / secondsDivider) % 60)

            const diff = eventDate - now
            if (diff > 0) {
                const countDownTemp = {
                    days: d,
                    hour: h,
                    minute: m,
                    second: s
                }
                setcountDown(countDownTemp)
                if (d > 0) {
                    return clearInterval(eventCountdown)
                }
                if (h > 0) {
                    return clearInterval(eventCountdown)
                }
                // console.log(`${d} Days  ${h} Hour ${m} Minute ${s} Seconds`)
            } else {
                // console.log("session completed")
                const countDownTemp = {
                    days: 0,
                    hour: 0,
                    minute: 0,
                    second: 0
                }
                setcountDown(countDownTemp)
                clearInterval(eventCountdown)
            }

        }, 1000)
    }

    const removeElement = () => {
        setFileURL(null);
        setFile(null);
        setIsOpen(false)
        // setVisible((prev) => !prev);
    };
    console.log("messages", messages);

    return (
        <aside className="bg-white relative rounded-2xl w-[45%] p-4 h-[92%] mt-12">
            {/* Header */}
            <div className="flex border-b border-[#FFDBB0] pb-6 items-center">
                {/* <Header /> */}
                <Header currentChatUser={currentChatUser} />
                <div className="flex font-ubuntu bg-[#FFDBB0] rounded-[40px] w-max xl:ml-16 h-8 items-center">
                    <div className="bg-white overflow-hidden rounded-2xl h-2 w-12 xl:w-12 my-auto ml-4 relative">
                        <div style={{ width: barStyle }} className="absolute bg-orange h-full top-0 left-0" />
                    </div>
                    <p className="flex-1 font-normal text-[8px] xl:text-[13px] mx-3">
                        {
                            currentChatUser?.session_date ?
                                <ReactTimeAgo
                                    date={getUserTime(currentChatUser?.session_date, currentChatUser?.session_time).toDate()}
                                />
                                : null
                        }</p>
                    <div className="flex-none cursor-pointer" onClick={handleVideoCall}>
                        <img src={zoomIcon} alt="" className="border-[#FFFFFF] w-[25px] h-[25px] border-[2px] rounded-3xl" />
                    </div>
                </div>
                <p className="flex  ml-14">
                    {flaggedStatus != 0 &&
                        <div><img src={flaggedIcon} alt="flaggedIcon" className="mr-2 h-6" title='This client is flagged' /></div>
                    }
                    <div className="bg-[#FFFFFF] w-[30px] rounded-[5px]">
                        <img onClick={() => setModalDisplay(true)} src={exclamationOrange} alt="" className="h-6 cursor-pointer" />
                    </div>
                </p>

                {modalDisplay &&
                    <ReportModal
                        currentChatUser={currentChatUser}
                        userFlaggedStatus={flaggedStatus}
                        onCloseModal={() => setModalDisplay(false)}
                    />
                }
                {
                    videoModal &&
                    <VideoJoinModal feedbackModal={feedbackModal} onCloseModal={() => setvideoModal(false)} videoLink={videoLink} currentChatUser={currentChatUser} />
                }
                {
                    feedback &&
                    <FeedbackCoach
                        booking_id={feedback.booking_id}
                        user_id={feedback.user_id}
                        feedbackClose={feedbackClose}

                    />
                    // <FeedbackCoach feedbackClose={feedbackClose} />
                }
            </div>

            {/* Conversation */}
            <SimpleBar className='lg:h-[40vh] xl:h-[60vh] 2xl:h-[70vh]' forceVisible="y" autoHide={false}>
                <div className="w-full mt-6  pt-4 pb-4 px-10">

                    <div ref={msgStartRef} />
                    {chatOpenLoading && !chatOpenSuccess &&
                        <img src={loader} className="w-48 h-48 mx-auto my-auto" alt="" />
                    }
                    {!chatOpenLoading && chatOpenSuccess &&
                        <>
                            {/* {console.log('hideShowMoreBtn', hideShowMoreBtn)} */}
                            {!hideShowMoreBtn &&
                                <div className="flex w-full justify-center my-2 gap-2">

                                    {messages?.length > 0 &&
                                        <Button title="Load Previous"
                                            onClick={() => handlePageChange()}
                                            className="bg-heavy font-bold font-ubuntu text-lightOrange px-4">👆</Button>
                                    }
                                </div>
                            }

                            {messages?.length === 0 &&
                                <div className="w-full h-auto my-auto flex justify-center items-center">
                                    <p className="text-1 font-bold font-ubuntu">No messages to show!</p>
                                </div>
                            }

                            {
                                (messages?.filter((d) => moment(moment().format("YYYY-MM-DD")).diff(moment(moment().format(d.created_at)), 'days') != 0
                                    && moment(moment().format("YYYY-MM-DD")).diff(moment(moment().format(d.created_at)), 'days') != 1))?.map((item, index) => {
                                        console.log(item)
                                        return (
                                            <div
                                                id={'mess' + index}
                                                key={item?.created_at ?? index}

                                                style={{
                                                    marginRight: item.from_user_id == currentChatUser?.user_id || item.message_type === "st" ? "auto" : "inherit",
                                                    marginLeft: item.from_user_id != currentChatUser?.user_id || item.message_type === "st" ? "auto" : "inherit"
                                                }}
                                                className={`${item.message_type === "st" ?
                                                    "w-max max-w-[85%] relative text-sm rounded-[40px] py-3 px-5" :
                                                    item.message_type === "div" ? " relative text-sm rounded-[40px] py-3 px-5" :
                                                        item?.file_link?.length > 2 ? "w-max max-w-[70%] relative text-sm rounded-[40px] mb-3 p-2  bg-[#fdf5ee]" : " w-max max-w-[70%] relative text-sm rounded-[40px] py-3 px-5"}`}
                                            >
                                              

                                                {/* {item?.message_type === 'i' && item?.file_link &&
                                                    <img
                                                        src={BASE_URL + item.file_link}
                                                        className="w-full mb-3 rounded-[40px]"
                                                        alt=""
                                                    />
                                                } */}
                                              {item?.message_type === 'i' && item?.file_link &&
    <img
        src={item.file_link.startsWith('data:') ? item.file_link : BASE_URL + item.file_link}
        className="w-full mb-3 rounded-[40px]"
        alt=""
    />
}

                                                {/* File message */}
                                                {/* {item?.message_type === 'f' && item?.file_link && (() => {
                                                    console.log("ggg");

                                                    const fileExt = item.file_link.split('.').pop()?.split('?')[0]?.toLowerCase() || '';
                                                    const rawName = item.file_link.split('/').pop() || 'File';
                                                    // decode %20 etc and strip unique suffix (e.g. "BOQ Template_6cqC5Sv.xlsx" → "BOQ Template.xlsx")
                                                    const decodedName = decodeURIComponent(rawName);
                                                    const fileIconMap = {
                                                        pdf: '📄',
                                                        xlsx: '📊', xls: '📊',
                                                        doc: '📝', docx: '📝',
                                                        csv: '📊',
                                                        txt: '📃',
                                                        zip: '🗜️', rar: '🗜️',
                                                    };
                                                    const icon = fileIconMap[fileExt] || '📎';

                                                    return (

                                                        <a href={BASE_URL + item.file_link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="flex items-center gap-2  rounded-2xl px-3 py-2  hover:bg-orange-50 transition-colors no-underline"
                                                        >
                                                            <span className="text-2xl">{icon}</span>
                                                            <div className="flex flex-col min-w-0">
                                                                <span className="text-[10px] font-medium text-gray-700 truncate max-w-[180px]">
                                                                    {decodedName}
                                                                </span>
                                                                <span className="text-[8px] text-gray-400 uppercase">
                                                                    {fileExt ? `${fileExt} file` : 'File'}
                                                                </span>
                                                            </div>
                                                            <MdFileDownload className="ml-auto text-orange text-lg flex-shrink-0" />
                                                        </a>
                                                    );
                                                })()} */}
                                                {item?.message_type === 'f' && item?.file_link && (() => {
    const isBase64 = item.file_link.startsWith('data:');
    const fileExt = isBase64
        ? item.file_link.split(';')[0].split('/')[1]
        : item.file_link.split('.').pop()?.split('?')[0]?.toLowerCase() || '';
    const decodedName = isBase64
        ? (item.file_name || 'File')
        : decodeURIComponent(item.file_link.split('/').pop() || 'File');
    const href = isBase64 ? item.file_link : BASE_URL + item.file_link;
    const fileIconMap = { pdf: '📄', xlsx: '📊', xls: '📊', doc: '📝', docx: '📝', csv: '📊', txt: '📃', zip: '🗜️', rar: '🗜️' };
    const icon = fileIconMap[fileExt] || '📎';
    return (
        <a href={href} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-2xl px-3 py-2 hover:bg-orange-50 transition-colors no-underline">
            <span className="text-2xl">{icon}</span>
            <div className="flex flex-col min-w-0">
                <span className="text-[10px] font-medium text-gray-700 truncate max-w-[180px]">{decodedName}</span>
                <span className="text-[8px] text-gray-400 uppercase">{fileExt ? `${fileExt} file` : 'File'}</span>
            </div>
            <MdFileDownload className="ml-auto text-orange text-lg flex-shrink-0" />
        </a>
    );
})()}
                                                {/* For displaying the date-wise division */}
                                                {
                                                    item.message_type === "div" &&
                                                    <div className="flex flex-row items-center">
                                                        <div className="text-[#868686] font-ubuntu text-xs !ml-[-20px] w-24">
                                                            {HTMLReactParser(checkForLinkInText(`${item.message}`))}
                                                        </div>
                                                        <div className="!w-full">
                                                            <div className="border-t-[2px] border-[#FFE2C0] ml-[10px]"></div>
                                                        </div>
                                                    </div>
                                                }

                                                {/* For displaying the status of message */}
                                                {
                                                    item.message_type === "st" &&
                                                    <div className="flex bg-[#fdf5ee] rounded-3xl p-2 mb-3 border-[#FFDBB0] border-[1px]">
                                                        <span className="w-[80%] text-[13px] pl-2 leading-4 text-[#868686] italic">{HTMLReactParser(checkForLinkInText(`${item.message}`))}</span>
                                                        <span className="w-[20%] absolute right-8 bottom-6 pt-2 text-right text-gray-400 text-[10px]">{moment.utc(item.created_at).tz(userTimezone).format('hh:mm a')}</span>
                                                    </div>
                                                }

                                                {
                                                    (item?.message_type === "st" || item?.message_type === "div") ? null :
                                                        <div className="w-full flex bg-[#fdf5ee] rounded-3xl p-2">
                                                            <div className="flex-1 text-[13px] left-0 !pr-8 !mr-8 leading-4 break-words whitespace-pre-wrap">{HTMLReactParser(checkForLinkInText(`${item.message}`))}</div>
                                                            <div className="flex-none absolute right-8 bottom-3 whitespace-nowrap align-text-bottom text-right text-gray-400 text-[10px]">{moment(item.created_at).format('hh:mm a')}</div>
                                                        </div>
                                                    
                                                }

                                            </div>
                                        )
                                    })
                            }




                            {/* Yesterday chat */}
                            {
                                messages?.filter((d) => moment(moment().format("YYYY-MM-DD HH:mm")).diff(moment(moment().format(d.created_at)), 'days') === 1).length > 0 ?
                                    <div className="flex flex-row items-center">
                                        <div className="text-[#868686] font-ubuntu text-xs">
                                            Yesterday
                                        </div>
                                        <div className="w-full">
                                            <div className="border-t-[2px] border-[#FFE2C0] ml-[10px]"></div>
                                        </div>

                                    </div> : null
                            }
                            {
                                (messages?.filter((d) => moment(moment().format("YYYY-MM-DD HH:mm")).diff(moment(moment().format(d.created_at)), 'days') === 1))?.map((item, index) => {
                                    console.log(item)
                                    return (
                                        <div
                                            id={'mess' + index}
                                            key={item?.created_at ?? index}

                                            style={{
                                                marginRight: item.from_user_id == currentChatUser?.user_id || item.message_type === "st" ? "auto" : "inherit",
                                                marginLeft: item.from_user_id != currentChatUser?.user_id || item.message_type === "st" ? "auto" : "inherit"
                                            }}
                                            className={`${item.message_type === "st" ?
                                                "w-max max-w-[85%] relative text-sm rounded-[40px] mb-3 p-2" :
                                                item?.file_link?.length > 2 ? "w-max max-w-[70%] relative text-sm rounded-[40px] mb-3 p-2 bg-[#fdf5ee]" :
                                                    "w-max max-w-[70%] relative text-sm rounded-[40px] mb-3 p-2"}`}
                                        // className={`${item.message_type === "st" ? " w-max max-w-[85%] relative text-sm rounded-[40px] py-3 px-5" : " w-max max-w-[70%] relative text-sm rounded-[40px] py-3 px-5"}`}
                                        >
                                            {/* 
                                            {item?.file_link?.length > 2 &&
                                           
                                                <img src={(BASE_URL + item?.file_link)} className="w-full my-3 rounded-[40px]" alt="" />
                                            } */}

                                            {/* {item?.message_type === 'i' && item?.file_link &&
                                                <img src={BASE_URL + item.file_link} className="w-full mb-3 rounded-[40px]" alt="" />
                                            } */}
                                           {item?.message_type === 'i' && item?.file_link &&
    <img
        src={item.file_link.startsWith('data:') ? item.file_link : BASE_URL + item.file_link}
        className="w-full mb-3 rounded-[40px]"
        alt=""
    />
}
                                            {/* {item?.message_type === 'f' && item?.file_link && (() => {
                                                const fileExt = item.file_link.split('.').pop()?.split('?')[0]?.toLowerCase() || '';
                                                const decodedName = decodeURIComponent(item.file_link.split('/').pop() || 'File');
                                                const fileIconMap = { pdf: '📄', xlsx: '📊', xls: '📊', doc: '📝', docx: '📝', csv: '📊', txt: '📃', zip: '🗜️', rar: '🗜️' };
                                                const icon = fileIconMap[fileExt] || '📎';
                                                return (
                                                    <a href={BASE_URL + item.file_link} target="_blank" rel="noopener noreferrer"
                                                        className="flex items-center bg-[#fdf5ee] gap-2 rounded-2xl px-3 py-2 hover:bg-orange-50 transition-colors no-underline">
                                                        <span className="text-2xl">{icon}</span>
                                                        <div className="flex flex-col min-w-0">
                                                            <span className="text-[10px] font-medium text-gray-700 truncate max-w-[180px]">{decodedName}</span>
                                                            <span className="text-[8px] text-gray-400 uppercase">{fileExt ? `${fileExt} file` : 'File'}</span>
                                                        </div>
                                                        <MdFileDownload className="ml-auto text-orange text-lg flex-shrink-0" />
                                                    </a>
                                                );
                                            })()} */}
                                            {item?.message_type === 'f' && item?.file_link && (() => {
    const isBase64 = item.file_link.startsWith('data:');
    const fileExt = isBase64
        ? item.file_link.split(';')[0].split('/')[1]
        : item.file_link.split('.').pop()?.split('?')[0]?.toLowerCase() || '';
    const decodedName = isBase64
        ? (item.file_name || 'File')
        : decodeURIComponent(item.file_link.split('/').pop() || 'File');
    const href = isBase64 ? item.file_link : BASE_URL + item.file_link;
    const fileIconMap = { pdf: '📄', xlsx: '📊', xls: '📊', doc: '📝', docx: '📝', csv: '📊', txt: '📃', zip: '🗜️', rar: '🗜️' };
    const icon = fileIconMap[fileExt] || '📎';
    return (
        <a href={href} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-2xl px-3 py-2 hover:bg-orange-50 transition-colors no-underline">
            <span className="text-2xl">{icon}</span>
            <div className="flex flex-col min-w-0">
                <span className="text-[10px] font-medium text-gray-700 truncate max-w-[180px]">{decodedName}</span>
                <span className="text-[8px] text-gray-400 uppercase">{fileExt ? `${fileExt} file` : 'File'}</span>
            </div>
            <MdFileDownload className="ml-auto text-orange text-lg flex-shrink-0" />
        </a>
    );
})()}
                                            {/* For displaying the status of message */}
                                            {
                                                item.message_type === "st" &&
                                                <div className="flex bg-[#fdf5ee] rounded-3xl p-2 mb-3 border-[#FFDBB0] border-[1px]">
                                                    <span className="w-[80%] text-[13px] pl-2 leading-4 text-[#868686] italic">{HTMLReactParser(checkForLinkInText(`${item.message}`))}</span>
                                                    <span className="w-[20%] absolute right-8 bottom-6 pt-2 text-right text-gray-400 text-[10px]">{moment.utc(item.created_at).tz(userTimezone).format('hh:mm a')}</span>
                                                </div>
                                            }
                                            {
                                                (item?.message_type === "st" || item?.message_type === "div") ? null :
                                                    <div className="w-full flex bg-[#fdf5ee] rounded-3xl p-2">
                                                        <div className="flex-1 text-[13px] left-0 !pr-8 !mr-8 leading-4 break-words whitespace-pre-wrap">{HTMLReactParser(checkForLinkInText(`${item.message}`))}</div>
                                                        <div className="flex-none absolute right-8 bottom-3 whitespace-nowrap align-text-bottom text-right text-gray-400 text-[10px]">{moment(item.created_at).format('hh:mm a')}</div>
                                                    </div>
                                                //                                                     <div className="w-full bg-[#fdf5ee] rounded-3xl p-2">
                                                //     <div className="text-[13px] leading-5 break-words whitespace-pre-wrap pr-14">
                                                //         {HTMLReactParser(checkForLinkInText(`${item.message}`))}
                                                //     </div>
                                                //     <div className="text-right text-gray-400 text-[10px] mt-1">
                                                //         {moment(item.created_at).format('hh:mm a')}
                                                //     </div>
                                                // </div>
                                            }
                                        </div>
                                    )
                                })
                            }


                            {/* Today messages */}
                            {
                                messages?.filter((d) => moment(moment().format("YYYY-MM-DD HH:mm")).diff(moment(moment().format(d.created_at)), 'days') === 0).length > 0 ?
                                    <div className="flex flex-row items-center my-2">
                                        <div className="text-[#868686] font-ubuntu text-xs">
                                            Today
                                        </div>
                                        <div className="w-full">
                                            <div className="border-t-[2px] border-[#FFE2C0] ml-[10px]"></div>
                                        </div>
                                    </div> : null
                            }
                            {
                                (messages?.filter((d) => moment(moment().format("YYYY-MM-DD HH:mm")).diff(moment(moment().format(d.created_at)), 'days') === 0))?.map((item, index) => {
                                    console.log("item",item)
                                    return (
                                        <div
                                            id={'mess' + index}
                                            key={item?.created_at ?? index}
                                            style={{
                                                marginRight: item.from_user_id == currentChatUser?.user_id || item.message_type === "st" ? "auto" : "inherit",
                                                marginLeft: item.from_user_id != currentChatUser?.user_id || item.message_type === "st" ? "auto" : "inherit"
                                            }}

                                            className={`${item.message_type === "st" ?
                                                "w-max max-w-[85%] flex-wrap relative text-sm rounded-[40px] mb-3  p-2" :
                                                item?.file_link?.length > 2 ? "w-max max-w-[70%] relative text-sm rounded-[40px] mb-3 p-2  bg-[#fdf5ee]" :
                                                    "w-max max-w-[70%] relative text-sm rounded-[40px] mb-3 p-2"}`}
                                        >


                                            {/* {item?.file_link?.length > 2 &&
                                           
                                                <img src={(BASE_URL + item?.file_link)} className="w-full my-3 rounded-[40px]" alt="" />
                                            } */}
                                            {/* {item?.message_type === 'i' && item?.file_link &&
                                                <img src={BASE_URL + item.file_link} className="w-full mb-3 rounded-[40px]" alt="" />
                                            } */}
                                           {item?.message_type === 'i' && item?.file_link &&
    <img
        src={item.file_link.startsWith('data:') ? item.file_link : BASE_URL + item.file_link}
        className="w-full mb-3 rounded-[40px]"
        alt=""
    />
}
                                            {/* {item?.message_type === 'f' && item?.file_link && (() => {
                                                const fileExt = item.file_link.split('.').pop()?.split('?')[0]?.toLowerCase() || '';
                                                const decodedName = decodeURIComponent(item.file_link.split('/').pop() || 'File');
                                                const fileIconMap = { pdf: '📄', xlsx: '📊', xls: '📊', doc: '📝', docx: '📝', csv: '📊', txt: '📃', zip: '🗜️', rar: '🗜️' };
                                                const icon = fileIconMap[fileExt] || '📎';
                                                return (
                                                    <a href={BASE_URL + item.file_link} target="_blank" rel="noopener noreferrer"
                                                        className="flex items-center gap-2 rounded-2xl px-3 py-2  hover:bg-orange-50 transition-colors no-underline">
                                                        <span className="text-2xl">{icon}</span>
                                                        <div className="flex flex-col min-w-0">
                                                            <span className="text-[10px] font-medium text-gray-700 truncate max-w-[180px]">{decodedName}</span>
                                                            <span className="text-[8px] text-gray-400 uppercase">{fileExt ? `${fileExt} file` : 'File'}</span>
                                                        </div>
                                                        <MdFileDownload className="ml-auto text-orange text-lg flex-shrink-0" />
                                                    </a>
                                                );
                                            })()} */}
                                            {item?.message_type === 'f' && item?.file_link && (() => {
    const isBase64 = item.file_link.startsWith('data:');
    const fileExt = isBase64
        ? item.file_link.split(';')[0].split('/')[1]
        : item.file_link.split('.').pop()?.split('?')[0]?.toLowerCase() || '';
    const decodedName = isBase64
        ? (item.file_name || 'File')
        : decodeURIComponent(item.file_link.split('/').pop() || 'File');
    const href = isBase64 ? item.file_link : BASE_URL + item.file_link;
    const fileIconMap = { pdf: '📄', xlsx: '📊', xls: '📊', doc: '📝', docx: '📝', csv: '📊', txt: '📃', zip: '🗜️', rar: '🗜️' };
    const icon = fileIconMap[fileExt] || '📎';
    return (
        <a href={href} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-2xl px-3 py-2 hover:bg-orange-50 transition-colors no-underline">
            <span className="text-2xl">{icon}</span>
            <div className="flex flex-col min-w-0">
                <span className="text-[10px] font-medium text-gray-700 truncate max-w-[180px]">{decodedName}</span>
                <span className="text-[8px] text-gray-400 uppercase">{fileExt ? `${fileExt} file` : 'File'}</span>
            </div>
            <MdFileDownload className="ml-auto text-orange text-lg flex-shrink-0" />
        </a>
    );
})()}
                                            {/* For displaying the status of message */}
                                            {
                                                item.message_type === "st" &&
                                                <div className="flex bg-[#fdf5ee] rounded-3xl p-2 mb-3 border-[#FFDBB0] border-[1px]">
                                                    <span className="w-[80%] text-[13px] pl-2 leading-4 text-[#868686] italic">{HTMLReactParser(checkForLinkInText(`${item.message}`))}</span>
                                                    <span className="w-[20%] absolute right-8 bottom-6 pt-2 text-right text-gray-400 text-[10px]">{moment.utc(item.created_at).tz(userTimezone).format('hh:mm a')}</span>
                                                </div>
                                            }
                                            {
                                                (item?.message_type === "st" || item?.message_type === "div") ? null :
                                                    <div className="w-full flex bg-[#fdf5ee] rounded-3xl p-2">
                                                        <div className="flex-1 text-[13px] left-0 !pr-8 !mr-8 leading-4 break-words whitespace-pre-wrap">{HTMLReactParser(checkForLinkInText(`${item.message}`))}</div>
                                                        <div className="flex-none absolute right-8 bottom-3 whitespace-nowrap align-text-bottom text-right text-gray-400 text-[10px]">{moment(item.created_at).format('hh:mm a')}</div>
                                                    </div>
                                                //                                                     <div className="w-full bg-[#fdf5ee] rounded-3xl p-2">
                                                //     <div className="text-[13px] leading-5 break-words whitespace-pre-wrap pr-14">
                                                //         {HTMLReactParser(checkForLinkInText(`${item.message}`))}
                                                //     </div>
                                                //     <div className="text-right text-gray-400 text-[10px] mt-1">
                                                //         {moment(item.created_at).format('hh:mm a')}
                                                //     </div>
                                                // </div>
                                            }

                                        </div>
                                    )
                                })
                            }
                            <div ref={messagesEndRef}></div>
                        </>
                    }



                    <div />
                </div>
            </SimpleBar>

            {/* Footer */}

            {currentChatUser?.is_relation_paused === "yes" &&
                <div className="w-[90%] bg-white absolute bottom-[100px] text-sm text-center text-orange font-ubuntu">
                    Your relation with this client is paused. Hence you can't send messages.
                </div>
            }
            {/* {fileURL &&
                <>
                    {visible && (
                        <div className="absolute bottom-16 left-10">
                            <button type="button" className="close aClass" onClick={removeElement}>
                                <span className="font-bold text-lg text-[#f76411]">&times;</span>
                            </button>
                            <img src={fileURL} alt="" className="w-16 h-16" />
                        </div>
                    )}
                </>

            } */}
            {fileURL &&
                <div className="absolute bottom-16 left-10">
                    <button type="button" className="close aClass" onClick={removeElement}>
                        <span className="font-bold text-lg text-[#f76411]">&times;</span>
                    </button>
                    {fileURL.startsWith('data:image') ? (
                        <img src={fileURL} alt="" className="w-16 h-16 rounded-lg object-cover" />
                    ) : (
                        <div className="flex items-center gap-2 bg-white border border-[#FFDBB0] rounded-xl px-3 py-2 shadow-sm">
                            <span className="text-xl">📎</span>
                            <span className="text-[11px] text-gray-600 max-w-[120px] truncate">
                                {file?.name || 'File selected'}
                            </span>
                        </div>
                    )}
                </div>
            }
            <div className="flex absolute bottom-6 w-full">
                <div className="flex bg-[#FDE9D8] rounded-[40px] w-[85%] h-10 p-2">
                    <input className="outline-none w-[95%] bg-[#FDE9D8] px-4 text-sm" name="message-text" id="message-text" placeholder="Type a message"
                        onChange={(e) => [
                            setCurrentMessage(e.target.value)
                        ]}
                        disabled={currentChatUser?.is_relation_paused === "yes" ? true : false}
                        value={currentMessage}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                sendMessageHandler()
                            }
                        }}
                        autoFocus
                    />
                    <input ref={sendFileRef}
                        disabled={currentChatUser?.is_relation_paused === "yes" ? true : false}
                        accept="image/*,.pdf,.xlsx,.xls,.doc,.docx,.csv,.txt"
                        onChange={(e) => {
                            setFile(e.target.files[0]);
                            const files = e.target.files[0];

                            if (!isOpen) {
                                setIsOpen(true)
                            }

                            var reader = new FileReader();
                            //eslint-disable-next-line
                            var url = reader.readAsDataURL(files);

                            reader.onloadend = function (e) {
                                setFileURL(...[reader.result])
                                //eslint-disable-next-line
                            }.bind(this);
                            // }
                        }} type="file" name="" id="" className="hidden" />
                    <div onClick={() => sendFileRef.current.click()} className="flex justify-center items-center border w-[30px] h-[30px] rounded-full bg-white border-heavyBorder ml-2 mt-[-3px] cursor-pointer">
                        <span className="text-xl font-bold text-orange-500 mt-[-5px]">+</span>
                    </div>
                </div>
                {currentChatUser?.is_relation_paused === "yes" ?
                    <div className="pl-2">
                        <img
                            src={RestrictIcon} alt="" className="border-[#FFFFFF] w-[40px] h-[40px] border-[2px] rounded-3xl cursor-not-allowed" />
                    </div> :
                    <div className="pl-2">
                        <img src={sendButton} onClick={sendMessageHandler} alt="" className="border-[#FFFFFF] w-[40px] h-[40px] border-[2px] rounded-3xl cursor-pointer" id="my-element" data-tooltip-content="Click to Send" />
                    </div>
                }
            </div>
            <ToastContainer />
            <ReactTooltip
                anchorId="my-element"
                variant="info"
                style={{ backgroundColor: "rgb(64 64 63 / 83%)", color: "rgb(255 255 255)" }} className="example-rounded"
                isOpen={isOpen}
            />
        </aside>
    )
}

export default Conversation



